import { cellTarget, defineGameCard, onAppear, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { selectedUnitId, SLIME_RESIDUE_ID, slimeSetDependencies, slimeUnitsInLocation, tableOf, trail, } from './slime-helpers.js';
const overlayPlanning = planningTargets((context, previous) => {
    const hostId = selectedUnitId(previous, 'host');
    return [
        targetStep('host', unitTarget({
            side: 'ally',
            cardinality: { min: 1, max: 1 },
            where: ({ unit }) => unit.traits.includes('SLIME'),
        })),
        targetStep('placement', cellTarget({
            side: 'ally',
            occupancy: 'occupied',
            cardinality: { min: 1, max: 1 },
            where: ({ cell }) => hostId !== undefined
                && cell.occupantId === hostId
                && context.units.some((unit) => unit.instanceId === hostId && unit.cellId === cell.cellId),
        })),
    ];
});
export const ColonyDevourerCard = defineGameCard({
    id: 'colony_devourer',
    gameplay: {
        type: 'UNIT', cost: 5, baseStats: { attack: 3, health: 4 }, traits: ['SLIME'],
        planning: { ...overlayPlanning, fieldPlacement: { kind: 'overlay', hostStepId: 'host' } },
    },
    presentation: {
        name: 'Пожиратель колонии',
        description: 'След 1. Можно сыграть поверх вашего слизня. При раскрытии поглощает его и остальных ваших слизней в этой локации, получая их базовую атаку и оставшееся здоровье.',
        glyph: {
            colors: ['#10213A', '#7155D4', '#916FE8', '#80BB45', '#80BB45'],
            rows: [
                '....................',
                '.....1111111111.....',
                '....122333333321....',
                '...11333333333311...',
                '..1223313313333321..',
                '..1333332222333331..',
                '..13332......33331..',
                '..133.........2321..',
                '.1233..........3221.',
                '.1232..........2221.',
                '1232...........22221',
                '122.444........22221',
                '12244444.......22221',
                '122414144....2222221',
                '124444444....2222221',
                '12444.44422222222221',
                '12244444442222222221',
                '.111111111111111111.',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeSetDependencies(SLIME_RESIDUE_ID),
    abilities: [
        trail(),
        // Host уже поглощён атомарной overlay placement-транзакцией движка (D53+):
        // receiver стоит в его ячейке. Появление пожирает ОСТАЛЬНЫХ своих слизней в
        // этой локации, суммируя их статы.
        onAppear((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return;
            const donors = slimeUnitsInLocation(ctx, self.controllerId, tableOf(self.cellId))
                .filter((donor) => donor.id !== self.id);
            if (donors.length > 0) {
                ctx.ops.absorbCards(self.id, donors.map((donor) => donor.id));
            }
        }, { cause: 'played' }),
    ],
    ui: {
        mechanics: ['trail', 'slime_residue', 'absorb'],
        planning: {
            steps: {
                host: { label: 'Выберите слизня-основу' },
                placement: { label: 'Подтвердите занятую ячейку' },
            },
        },
    },
});
//# sourceMappingURL=colony_devourer.js.map